const normalizeString = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value).trim().toLowerCase();
};

const expandCandidate = (value, collector) => {
  if (!value) {
    return;
  }
  const raw = String(value);
  raw
    .split(/[;,\/|-]/)
    .map((part) => normalizeString(part))
    .filter(Boolean)
    .forEach((entry) => collector.add(entry));
};

export const mapPretiumDolorisOptions = (data = []) => {
  return (Array.isArray(data) ? data : [])
    .map((item) => {
      const value = item?.points ?? item?.point ?? item?.value;
      const label = item?.qualification ?? item?.libelleParametre ?? item?.label;
      if (value === null || value === undefined || !label) {
        return null;
      }
      return {
        value: Number(value),
        label: String(label).trim(),
      };
    })
    .filter(Boolean)
    .sort((a, b) => Number(a.value) - Number(b.value));
};

export const selectApplicableSmig = (smigList = [], sinistre) => {
  if (!Array.isArray(smigList) || smigList.length === 0) {
    return null;
  }

  const candidates = new Set();
  expandCandidate(sinistre?.lieu, candidates);
  expandCandidate(sinistre?.contrat?.souscripteur?.nationalite, candidates);
  expandCandidate(sinistre?.contrat?.souscripteur?.adresse, candidates);
  expandCandidate(sinistre?.contrat?.assure?.nationalite, candidates);
  expandCandidate(sinistre?.contrat?.assure?.adresse, candidates);

  const sorted = [...smigList].sort((a, b) => {
    const dateA = a?.dateDebutApplication ? new Date(a.dateDebutApplication) : null;
    const dateB = b?.dateDebutApplication ? new Date(b.dateDebutApplication) : null;

    if (dateA && dateB && dateA.getTime() !== dateB.getTime()) {
      return dateB - dateA;
    }
    if (!dateA && dateB) {
      return 1;
    }
    if (!dateB && dateA) {
      return -1;
    }
    const idA = a?.smigId ?? 0;
    const idB = b?.smigId ?? 0;
    return idB - idA;
  });

  const matched = sorted.find((item) => {
    const normalizedPays = normalizeString(item?.pays);
    if (!normalizedPays) {
      return false;
    }
    if (candidates.size === 0) {
      return false;
    }
    return candidates.has(normalizedPays);
  });

  const fallback =
    matched ||
    sorted.find((item) => item?.dateFinApplication === null || item?.dateFinApplication === undefined) ||
    sorted[0];

  const value = fallback?.montantSmig;
  return value !== null && value !== undefined ? Number(value) : null;
};

export const findPretiumLabel = (options = [], rawValue) => {
  if (rawValue === null || rawValue === undefined) {
    return "";
  }
  const numeric = Number(rawValue);
  const match = options.find((option) => Number(option.value) === numeric);
  return match?.label ?? "";
};
